import React from 'react'
import { Link } from 'react-router-dom'
import logo from '@/assets/images/Footer-logo.svg'

import facebook from '@/assets/images/footer/facebook.svg'
import instagram from '@/assets/images/footer/instagram.svg'
import payments from '@/assets/images/footer/paymentsupport.png'
import { AiOutlineInstagram, AiOutlineWhatsApp } from 'react-icons/ai'
import { FaFacebookF } from 'react-icons/fa'

import './Footer.scss'
import { useTranslation } from 'react-i18next'

const Footer = () => {
	const { t } = useTranslation()
	return (
		<>
			<footer>
				<div className='container-xxl'>
					<div className='row footer-row-menu'>
						<div className='col-12 col-md-4'>
							<div className='logo'>
								<img src={logo} alt='' />
							</div>
							<p className='logo_description left_footer'>
								{t(
									'a_service_for_quick_and_easy_registration_of_travel_anywhere_in_the_world'
								)}
							</p>
						</div>
						<div className='col-12 col-md-2 offset-lg-1'>
							<p className='title_footer'>{t('Menu')}</p>
							<ul className='footer_list'>
								<Link to='/search-tours'>
									<li className='list_item'>
										{t('search_tours')}
									</li>
								</Link>
								<Link to='/'>
									<li className='list_item'>{t('main')}</li>
								</Link>
								<Link to='/contacts'>
									<li className='list_item'>
										{t('contacts')}
									</li>
								</Link>
								<Link to='/blog'>
									<li className='list_item'>{t('blog')}</li>
								</Link>
							</ul>
						</div>
						<div className='col-12 col-md-3'>
							<p className='title_footer'>{t('additionally')}</p>
							<ul className='footer_list'>
								<Link to='/terms'>
									<li className='list_item'>
										{t('refund_policy')}
									</li>
								</Link>
								<Link to='/privacy-policy'>
									<li className='list_item'>
										{t('security_policy')}
									</li>
								</Link>
								<Link to='/cookies'>
									<li className='list_item'>
										{t('cookie_policy')}
									</li>
								</Link>
								<Link to='/return-policy'>
									{' '}
									<li className='list_item'>
										{t('terms_of_service')}
									</li>
								</Link>
							</ul>
						</div>
						<div className='col-12 col-md-2 last-col-contact'>
							<p className='title_footer'>{t('contacts')}</p>
							<ul className='footer_list'>
								<a href='tel:+37126619971'>
									<li className='list_item'>
										+371 26 619 971
									</li>
								</a>
								<a href='mailto:info@mandarina.lv'>
									<li className='list_item'>
										info@mandarina.lv
									</li>
								</a>
							</ul>
						</div>
					</div>
					<div className='row'>
						<div className='col-12'>
							<div className='soc_network'>
								<div className='title_footer title_icons_soc_network'>
									{t('social_mes')}
								</div>
								<div className='icons_soc_network'>
									<a
										href='http://fb.com/mandarina.lv'
										className='hvr-event'
										target='_blank'
									>
										<FaFacebookF className='FaFacebookF' />
									</a>
									<a
										href='https://www.instagram.com/mandarina.lv/'
										className='hvr-event'
										target='_blank'
									>
										<AiOutlineInstagram className='AiOutlineInstagram' />
									</a>
									<a
										href='https://wa.me/37126619971'
										className='hvr-event'
										target='_blank'
									>
										<AiOutlineWhatsApp className='AiOutlineInstagram' />
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className='copyright_wrap'>
					<div className='container-xxl'>
						<div className='row copyright_row'>
							<div className='col-12 col-md-4 logo_description center-alig'>
								MANDARINA - © 2025 {t('all_rights_reserved')}
								<p className=''>
									Website Developed by{' '}
									<a
										href='https://smartnwild.com/'
										target='_blank'
									>
										Smart & Wild
									</a>
								</p>
							</div>
							{/* <div className='col-12 col-md-4 logo_description center-alig'></div> */}
							<div className='col-12 col-md-4'>
								<img
									src={payments}
									alt=''
									className='payment'
								/>
							</div>
						</div>
					</div>
				</div>
			</footer>
			<a
				href='https://wa.me/37126619971'
				target='_blank'
				rel='noopener noreferrer'
				aria-label='WhatsApp'
				title='WhatsApp'
				className='whatsapp-float-btn'
			>
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='24'
					height='24'
					fill='currentColor'
					className='bi bi-whatsapp'
					viewBox='0 0 16 16'
					aria-hidden='true'
				>
					<path d='M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z'></path>
				</svg>
			</a>
		</>
	)
}

export default Footer
